import { ObjectMapper } from 'json-object-mapper';
import { IModel } from '../../IModel';
import { Model } from '../../model';
import { WCKOccurrenceStatusEnum } from './enum/WCKOccurrenceStatus.enum';
import { ActionPlanModel } from '../action-plan/action-plan.model';

export class WCKOccurrenceModel extends Model implements IModel<WCKOccurrenceModel> {
  public eventLocationId: string = '';
  public occurrenceTypeId: string = '';
  public companyGroupId: string = '';
  public creatorId: string = '';
  public date: string = '';
  public description: string = '';
  public criticalPoints: string = '';
  public fileName: string = '';
  public fileKey: string = '';
  public internalParticipantIds: string[] = [];
  public externalParticipants: string[] = [];
  public actions: ActionPlanModel[] = [];
  public type: string = '';
  public creatorName: string = '';
  public status: string = '';
  public currentStatus: string = '';
  public totalActions: number = 0;
  public totalFinishedActions: number = 0;
  public eventLocation: string = '';

  get statusBadge(): string {
    const status = WCKOccurrenceStatusEnum.getBy(this.currentStatus);
    return `<span class="badge badge-light-${status?.className} text-wrap">${status?.label}</span>`;
  }

  get statusIsDraft() {
    return this.currentStatus === WCKOccurrenceStatusEnum.DRAFT.value;
  }

  static create(input: any): WCKOccurrenceModel {
    return ObjectMapper.deserialize<WCKOccurrenceModel>(WCKOccurrenceModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
